import React from 'react';
import {
    NavigateFunction,
    useParams,
    useNavigate,
    useLocation,
} from 'react-router-dom';

export interface RouteComponentProps<
    Params extends { [K in keyof Params]?: string } = {}
> {
    params: Params;
    navigate: NavigateFunction;
    location: Location;
}
export function withRouter<
    Params extends { [K in keyof Params]?: string },
    P extends RouteComponentProps<Params>
>(WrappedComponent: React.ComponentType<P>) {
    function ComponentWithRouterProps(
        props: Omit<P, keyof RouteComponentProps<Params>>
    ) {
        const params = useParams<Params>();
        const navigate = useNavigate();
        const location = useLocation();

        return (
            <WrappedComponent
                {...(props as P)}
                params={params}
                navigate={navigate}
                location={location}
            />
        );
    }

    return ComponentWithRouterProps;
}
